import { render } from "./Chance.vue?vue&type=template&id=cc92261a&ts=true"
import script from "./Chance.vue?vue&type=script&lang=ts"
export * from "./Chance.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__